//#region src/utils/hide-metadata.ts
const HIDE_METADATA = { scope: "server" };
//#endregion
export { HIDE_METADATA };
